export default (node) => {
  /**
   * Data + elements
   */
  const days = node.querySelector('[data-days]');
  const hours = node.querySelector('[data-hours]');
  const minutes = node.querySelector('[data-minutes]');
  const seconds = node.querySelector('[data-seconds]');
  const expirationDateText = node.dataset.expiresAt;

  const expirationBehavior = node.dataset.expirationBehavior;
  const startDateText = node.dataset.startDate;
  let intervalTimer;


  /**
   * Functions
   */

  const calculateCounter = () => {
    const dateNow = new Date().getTime();
    const expirationDate = new Date(expirationDateText).getTime();

    if (expirationDate < dateNow) {
      if (expirationBehavior === 'hide') {
        node.remove();
      } else {
        clearInterval(intervalTimer);
      }
    }

    let delta = expirationDate - dateNow;

    const daysNew = Math.floor(delta / (1000 * 60 * 60 * 24));
    const remainingHours = Math.floor(
      (delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const remainingMinutes = Math.floor(
      (delta % (1000 * 60 * 60)) / (1000 * 60)
    );
    const remainingSeconds = Math.floor((delta % (1000 * 60)) / 1000);


    days.innerText =
      daysNew < 0 ? '00' : daysNew < 10 ? `0${daysNew}` : daysNew;
    hours.innerText =
      remainingHours < 0
        ? '00'
        : remainingHours < 10
          ? `0${remainingHours}`
          : remainingHours;
    minutes.innerText =
      remainingMinutes < 0
        ? '00'
        : remainingMinutes < 10
          ? `0${remainingMinutes}`
          : remainingMinutes;
    seconds.innerText =
      remainingSeconds < 0
        ? '00'
        : remainingSeconds < 10
          ? `0${remainingSeconds}`
          : remainingSeconds;

    if (daysNew <= 0 && remainingHours <= 0 && remainingMinutes <= 0 && remainingSeconds <= 0) {
      node.classList.add('hidden');
    }
  };

  /**
   * Init
   */
  const init = () => {
    // check if the start date is in the past
    const startDate = new Date(startDateText).getTime();
    if (startDate < new Date().getTime()) {
      node.classList.remove('hidden');
      intervalTimer = setInterval(calculateCounter, 1000);
    } else {
      node.classList.add('hidden');
    }

    const hero = document.querySelector('[data-first-section-hero]');
    if (hero) {
      const heroComponent = hero.querySelector('[data-component="hero"]');
      if (heroComponent) heroComponent.style.height = 'calc(100vh - 68px)';
    }
  };

  init();
};
